import * as TanstackQuery from '@barbershop/providers/tanstack-query'
import { createRouter, RouterProvider } from '@tanstack/react-router'

import { routeTree } from '@/app/route-tree.generated'

const router = createRouter({
    routeTree,
    context: {
        ...TanstackQuery.getContext(),
    },
    defaultPreload: 'intent',
    scrollRestoration: true,
    defaultStructuralSharing: true,
    defaultPreloadStaleTime: 0,
    notFoundMode: 'root',
})

declare module '@tanstack/react-router' {
    interface Register {
        router: typeof router
    }
}

export const WithTanstackRouter = () => {
    return <RouterProvider router={router} />
}
